import React from "react";
import {Table} from "react-bootstrap";
import {ColumnDef, flexRender, getCoreRowModel, useReactTable,} from "@tanstack/react-table";

export const TanStackRawDataTable: React.FC<{
    data: any[]
}> = ({ data }) => {
    const columns = React.useMemo<ColumnDef<any>[]>(() => [
        {accessorKey: "0", header: ""},
        {accessorKey: "A", header: "1"},
        {accessorKey: "B", header: "2"},
        {accessorKey: "C", header: "3"},
        {accessorKey: "D", header: "4"},
        {accessorKey: "E", header: "5"},
        {accessorKey: "F", header: "6"},
        {accessorKey: "G", header: "7"},
        {accessorKey: "H", header: "8"},
        {accessorKey: "I", header: "9"},
        {accessorKey: "J", header: "10"},
        {accessorKey: "K", header: "11"},
        {accessorKey: "L", header: "12"},
    ], [])

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    })

    const noData = data.length === 0

    return (
        <div className="table-responsive">
            <Table bordered hover>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th key={header.id}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                {noData ? (
                    <tr>
                        <td colSpan={columns.length}>
                            <h6 className="text-primary">No data found!</h6>
                        </td>
                    </tr>
                ) : (
                    table.getRowModel().rows.map((row) => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))
                )}
                </tbody>
            </Table>
        </div>
    )
}